// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Payment Method Changed</h1>
        </div>
        <div class="hoa-dialog__main">
            You changed your payment method
            from <span class="u-textNoWrap">{{data.oldPaymentMethod}}</span>
            to <span class="u-textNoWrap">{{data.newPaymentMethod}}</span>.

            <ng-container *ngIf="data.feeChanged">
                The administrative fee changed
                from
                <span class="u-textNoWrap">
                    <ng-container *ngIf="data.oldIsPercentage; else oldFeeAsCurrency">
                        {{data.oldFee}}%
                    </ng-container>
                    <ng-template #oldFeeAsCurrency>
                        {{data.oldFee | currency}}
                    </ng-template>
                </span>
                to
                <span class="u-textNoWrap">
                    <ng-container *ngIf="data.newIsPercentage; else newFeeAsCurrency">
                        {{data.newFee}}%
                    </ng-container>
                    <ng-template #newFeeAsCurrency>
                        {{data.newFee | currency}}
                    </ng-template>
                </span>.
                <br>
                <p>Please click 'OK' to accept new administrative fee.</p>
            </ng-container>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="confirmNewFeeNoButton"
                    class="Button Button--link Button--minWidth130"
                    (click)="closeThisDialog('Cancel')">
                Cancel
            </button>
            <button tid="confirmNewFeeYesButton"
                    class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('OK')">
                OK
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;